<template>
  <div id="salesperson">
    <div class="vx-card">
      <div class="vx-card__body card-body" v-has-permission="permission54">
        <div class="vx-row">
          <div class="vx-col lg:w-5/6 w-full mb-6">
            <label class="vs-select--label">{{ $t("UserName") }}</label>
            <treeselect
              name="user"
              :multiple="false"
              :placeholder="$t('SearchUser')"
              :async="true"
              :load-options="loadUserOptions"
              ref="user"
              @select="onUserSelected"
            />
          </div>
          <div class="vx-col lg:w-1/6 w-full">
            <vs-button
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-plus"
              class="add-btn"
              @click.prevent="addSalesPerson"
            ></vs-button>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('FullName') },
                { title: $t('User') },
                { title: $t('ID') },
                { title: $t('CreateOn') },
                { title: $t('Admin') },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 20%">
                  {{ row.firstName }}
                </td>
                <td style="width: 20%">
                  {{ row.userName }}
                </td>
                <td style="width: 10%">
                  {{ row.id }}
                </td>
                <td style="width: 15%; direction: ltr">
                  {{ row.createOn.split(" ")[0] }}<br />{{
                    row.createOn.split(" ")[1]
                  }}
                </td>
                <td style="width: 20%">
                  <span v-if="row.adminInfo"
                    >{{
                      row.adminInfo.fullName && row.adminInfo.fullName.length
                        ? row.adminInfo.fullName
                        : row.adminInfo.userName
                    }}
                    <vs-button
                      radius
                      color="success"
                      size="small"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-edit"
                      @click.prevent="onSelectAdmin(row)"
                      class="mr-4 ml-2 d-inline"
                    ></vs-button>
                    <vs-button
                      radius
                      color="danger"
                      size="small"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-x"
                      @click.prevent="deleteAssignAdmin(row.id)"
                      class="d-inline"
                    ></vs-button>
                  </span>
                  <span v-else>
                    <vs-button
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-edit"
                      class="bordered-btn"
                      @click.prevent="onSelectAdmin(row)"
                      >{{ $t("SelectAdmin") }}</vs-button
                    >
                  </span>
                </td>
                <td style="width: 25%">
                  <vs-button
                    color="primary"
                    type="border"
                    icon-pack="feather"
                    icon="icon-edit"
                    class="bordered-btn"
                    @click.prevent="onAgentPopup(row)"
                    v-has-permission="permission53"
                    >{{ $t("Agents") }}</vs-button
                  >
                  <vs-button
                    radius
                    color="danger"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-x"
                    @click.prevent="deleteSalesperson(row.id)"
                    class="d-inline mr-4"
                    v-has-permission="permission55"
                  ></vs-button>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
        <agent-popup
          :show="isShowAgentPopup"
          :model="salePersonModel"
          @close="closeAgentPopup"
        ></agent-popup>
        <select-admin-popup
          :show="isShowSelectAdminPopup"
          :model="salePersonModel"
          @finish="onFinish"
          @close="closeSelectAdminPopup"
        ></select-admin-popup>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.add-btn:hover i {
  color: #fff !important;
}
#salesperson .bordered-btn:hover {
  color: #097272 !important;
}
.bordered-btn {
  margin: 0 5px !important;
}
</style>
<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import Treeselect from "@/components/CustomTreeSelect.vue";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import DataGrid from "@/components/datagrid/DataGrid";
import AgentPopup from "./AgentPopup.vue";
import SelectAdminPopup from "./SelectAdminPopup.vue";
const dict = {
  custom: {
    customer: {
      required: "لطفا نام مشتری را انتخاب نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "saleManagement_SalesPersons_Index",
  components: {
    Treeselect,
    DataGrid,
    AgentPopup,
    SelectAdminPopup,
  },
  data() {
    return {
      permission53: "",
      permission54: "GetAllSalePersons",
      permission55: "",
      model: {
        userId: null,
        userName: "",
        firstName: "",
        lastName: "",
      },
      disabled: false,
      gridDataSource: {
        type: "app",
        service: "Sales/api/SalePersonQuery",
      },
      gridSearchData: {},
      isShowAgentPopup: false,
      isShowSelectAdminPopup: false,
      salePersonModel: {},
      searchQueryNew: "",
      searchQueryOld: "",
    };
  },
  methods: {
    ...mapActions({
      searchCustomerByPhone: "identityAccess/searchCustomerByPhone",
      createSalesPerson: "sale/createSalesPerson",
      removeSalesPerson: "sale/deleteSalesPerson",
      removeAssignAdminToSalesPerson: "sale/deleteAssignAdminToSalesPerson",
    }),
    loadUserOptions({ action, searchQuery, callback }) {
      this.searchQueryNew = searchQuery;
      this.searchQueryOld = this.searchQueryNew;
      setTimeout(() => {
        this.searchQueryNew = searchQuery;
        if (this.searchQueryOld == this.searchQueryNew) {
          if (action === ASYNC_SEARCH) {
            this.searchCustomerByPhone(searchQuery).then((r) => {
              const options = [];
              r.forEach(function (element) {
                options.push({
                  id: element.id,
                  userName: element.userName,
                  label: element.userName,
                });
              });
              callback(null, options);
            });
          }
        }
      }, 800);
    },
    addSalesPerson() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.createSalesPerson(this.model)
            .then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
                showConfirmButton: false,
                timer: 2000,
              });
              this.$refs.grid.renderGrid();
            })
            .catch(() => {
              this.disabled = false;
            });
          this.$refs.user.clear();
        }
      });
    },
    deleteSalesperson(id) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.removeSalesPerson(id).then(() => {
            this.$refs.grid.renderGrid();
          });
        }
      });
    },

    createSalePersonName(model) {
      this.salePersonModel = {
        salePersonId: model.id,
        salePersonName: model.firstName
          ? model.firstName + " " + model.lastName
          : "",
      };
    },
    deleteAssignAdmin(rowId) {
      this.$swal({
        title: "آیا از حذف ادمین برای این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.removeAssignAdminToSalesPerson(rowId).then(() => {
            this.$refs.grid.renderGrid();
          });
        }
      });
    },
    onAgentPopup(model) {
      this.createSalePersonName(model);
      this.isShowAgentPopup = true;
    },
    onUserSelected(data) {
      this.model.userId = data.id;
      this.model.userName = data.userName;
    },
    onSelectAdmin(model) {
      this.createSalePersonName(model);
      this.isShowSelectAdminPopup = true;
    },
    closeAgentPopup() {
      this.isShowAgentPopup = false;
    },
    closeSelectAdminPopup() {
      this.isShowSelectAdminPopup = false;
    },
    onFinish() {
      this.closeSelectAdminPopup();
      this.$refs.grid.renderGrid();
    },
  },
};
</script>
